import { cx } from "@linaria/core"
import { observer } from "mobx-react-lite"

import { Button } from "@/components/Button/Button.tsx"
import { StyledUserMessageBalloon } from "@/components/Chat/UserMessageStyles.ts"
import { Horizontal, Vertical } from "@/components/Flex.ts"
import { CompletionDropdown } from "@/components/PromptInput/Completion/CompletionDropdown.tsx"
import { PromptTextArea } from "@/components/PromptInput/PromptInput.tsx"
import { PromptInputStyles } from "@/components/PromptInput/PromptInputStyles.ts"

import type { PromptInputModel } from "@/components/PromptInput/PromptInputModel.ts"


export const EditPromptInput = observer((props: {
  model: PromptInputModel
  cancel: () => void
}) => {
  const model = props.model

  const isDragging = model.isDragging.get()
  const isSubmitting = model.isSubmitting.get()
  const canSubmit = model.canSubmit.get()

  const isModified = model.firstInputValue.get() != model.initialValue

  return (
    <StyledUserMessageBalloon
      className={cx(isSubmitting ? PromptInputStyles.Highlighted : null)}
      isMyMessage
    >
      <Vertical gap="8px">
        <form
          ref={model.containerRef}
          onClick={() => model.inputRef.current?.focus()}
          className={cx(isDragging ? PromptInputStyles.Highlighted : null)}
          onSubmit={model.onSubmit}
          onDragOver={model.handleDragOver}
          onDragLeave={model.handleDragLeave}
          onDrop={model.handleDrop}
        >
          <CompletionDropdown model={model.completionModel} />

          <PromptTextArea
            model={model}
            placeholder="Edit message"
            onCancel={props.cancel}
            onSubmit={props.model.doSubmit}
          />
        </form>

        <Horizontal gap="8px" justifyContent="flex-end">
          <Button kind="alternative" onClick={props.cancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            kind="primary"
            onClick={props.model.doSubmit}
            disabled={!canSubmit || isSubmitting || !isModified}
            data-testid="save-button"
          >
            Save
          </Button>
        </Horizontal>
      </Vertical>
    </StyledUserMessageBalloon>
  )
})